import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/reservations/:parkingId/vehicle-stay-reservation/:reservationId/cancel/';

interface DTO {
    parkingId: string;
    reservationId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, reservationId }: DTO): Promise<void> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, reservationId }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as CANCEL_RESERVATION_RESOURCE, useMutationHook as useCancelReservation };
export type { DTO as CancelReservationDTO };
